var _defs, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcBadgeVerified(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.124 1.24a.962.962 0 00-1.247 0l-1.525 1.3a.962.962 0 01-.547.227l-1.997.159a.962.962 0 00-.882.882l-.16 1.997a.962.962 0 01-.226.547l-1.3 1.525a.962.962 0 000 1.247l1.3 1.525c.131.154.21.346.227.547l.159 1.997c.037.471.411.845.882.882l1.997.16a.961.961 0 01.547.226l1.525 1.3a.961.961 0 001.247 0l1.525-1.3a.961.961 0 01.547-.226l1.997-.16a.961.961 0 00.882-.882l.16-1.997a.961.961 0 01.226-.547l1.3-1.525a.961.961 0 000-1.247l-1.3-1.525a.961.961 0 01-.226-.547l-.16-1.997a.961.961 0 00-.882-.882l-1.997-.16a.962.962 0 01-.547-.226l-1.525-1.3zm2.041 5.815a.56.56 0 10-.844-.738L7.85 9.139 6.253 7.861a.56.56 0 00-.7.876L7.33 10.16a.881.881 0 001.214-.108l2.621-2.996z",
    clipRule: "evenodd"
  })));
}

export default SvgIcBadgeVerified;